import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from '../../nest-responses';
import { RequestAddPurposeTypeDto, ResponseGetPurposeTypeDto, RequestEditPurposeTypeDto } from '../dto/businesstrip.dto';

@Injectable()
export class BusinesstripApi {

  private service: string = '';
  private model: string = 'businesstrip';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getPurposeType(page: string | number, limit: string | number): Observable<ResponseGetPurposeTypeDto> {
    const method: string = 'GET';
    const func: string = 'getPurposeType';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetPurposeTypeDto>(method, url, func, params, body);
  }

  public getCancelRequest(requestNo: string): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getCancelRequest';
    const params: any = {};
    const urlParams: any = { requestNo };
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, func, params, body);
  }

  public addPurposeType(payload: RequestAddPurposeTypeDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'addPurposeType';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public editPurposeType(payload: RequestEditPurposeTypeDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'editPurposeType';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/businesstrip.api.ts